import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';
import Currency from 'components/Currency';

const OfferPayableAtProperty = ({ payableAtProperty, isIncludedInTotal }) =>
  Number(payableAtProperty.amount) > 0 && (
    <Box
      textAlign={['left', 'right']}
      mt={2}
      mb={2}
      color="greys.steel"
      lineHeight="tight"
      fontSize="sm"
      display="inline-block"
      data-testid="fee-payable-at-property"
    >
      {isIncludedInTotal ? 'Includes' : 'Excludes'} fees of{' '}
      <Currency amount={payableAtProperty.amount} currency={payableAtProperty.currency} fontSize="base" fontWeight="bold" /> payable in
      local currency on check-out
    </Box>
  );

OfferPayableAtProperty.propTypes = {
  payableAtProperty: PropTypes.shape({
    amount: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  isIncludedInTotal: PropTypes.bool.isRequired,
};

export default OfferPayableAtProperty;
